import { render, staticRenderFns } from "./ProductItemInventoryEdit.vue?vue&type=template&id=dc47f7a4&"
import script from "./ProductItemInventoryEdit.vue?vue&type=script&lang=js&"
export * from "./ProductItemInventoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemInventoryEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports